import { useEffect, useState } from "react";
import AttractionItem from "Attractions/AttractionItem";
export default function TimeLine({ dailySchedule, daysLength, weather,tourAttractions }) {
  console.log(
    "tourAttractions",tourAttractions
  )
  const [timeLineData, setTimeLineData] = useState([]);

  function translateWeather(dayNum) {
    if (weather) {
      switch (weather.split("+")[dayNum]) {
        case "snow":
          return "برفی";
        case "rain":
          return "بارانی";
        case "sun":
          return "آفتابی";
        default:
          return "اطلاعات در دسترس نیست.";
      }
    }
  }

  function DayData(dayNum) {
    return timeLineData[dayNum].map((value) => {
      var title = "";
      switch (+value.type) {
        case 0:
          title = "صبحانه";
          break;

        case 1:
          title = "گشت صبح";

          break;
        case 2:
          title = "ناهار";

          break;
        case 3:
          title = "گشت عصر";

          break;
        case 4:
          title = "میان وعده";

          break;
        case 5:
          title = "شام";

          break;
        case 6:
          title = "برنامه شب";
          break;
        default:
          break;
      }
      switch (+value.type) {
        case 1:
        case 3:
        case 6:
          return (
            <>
              <div className="timeline">
                <div href="#" className="timeline-content">
                  <h3 className="title d-flex flex-row mb-2">{title}</h3>
                  <p className="description">
                    {title + " "}
                    در
                    {" " + value.title + " "}
                    خواهیم داشت.
                  </p>
                </div>
              </div>
            </>
          );

        default:
          return (
            <>
              <div className="timeline">
                <div href="#" className="timeline-content">
                  <h3 className="title d-flex flex-row mb-2">{title}</h3>
                  <p className="description">
                    {value.foodname + " "}
                    در رستوران
                    {" " + value.Account_side_name + " "}
                    سرو خواهد شد
                  </p>
                </div>
              </div>
            </>
          );
      }
    });
  }
  useEffect(() => {
    if (dailySchedule && daysLength) {
      let temp = dailySchedule
        .filter((value) => +value.ispublic)
        .filter((value) => {
          if (+value.type == 1 || +value.type == 3 || +value.type == 6) {
            return !!value.title;
          } else {
            return !!value.foodname && !!value.Account_side_name;
          }
        });
      let dayArray = Array.from({ length: daysLength }, () => []);
      for (let index = 0; index < temp.length; index++) {
        dayArray[+temp[index].daynum].push(temp[index]);
      }
      for (let index = 0; index < dayArray.length; index++) {
        dayArray[index].sort(function (a, b) {
          return a.type - b.type;
        });
      }

      setTimeLineData(dayArray);
    }
  }, [dailySchedule, daysLength]);
  return (
    <>
      {/* timeline */}
      <div className="col-lg-8 col-sm-12 ">
        <ul className="nav nav-tabs" id="myTab" role="tablist">
        <li className="nav-item" role="presentation">
                <button className={`nav-link Days active`} id="home-tab" data-bs-toggle="tab" data-bs-target={`#attractions-btn`} type="button" role="tab" aria-controls="home" aria-selected="true">
                 جاذبه ها
                </button>
              </li>
          {[...Array(daysLength)].map((value, index) => {
            return (
              <li className="nav-item" role="presentation">
                <button className={`nav-link Days `} id="home-tab" data-bs-toggle="tab" data-bs-target={`#day-tab-${index + 1}`} type="button" role="tab" aria-controls="home" aria-selected="true">
                  {index == 0 ? "روز حرکت" : `روز ${index}`}
                </button>
              </li>
            );
          })}
            
        </ul>
        <div className="tab-content" id="myTabContent">
        <div className={`tab-pane fade show active`} id={`attractions-btn`} role="tabpanel" aria-labelledby="home-tab">
                <div className="container">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="main-timeline d-flex flex-wrap justify-content-center">
                        {tourAttractions.map((value)=>{
 return <AttractionItem information= {value}></AttractionItem>
                        })}
                      
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          {[...Array(daysLength)].map((value, index) => {
            return (
              <div className={`tab-pane fade show `} id={`day-tab-${index + 1}`} role="tabpanel" aria-labelledby="home-tab">
                <div className="container">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="main-timeline">
                        <p>
                          آب و هوا:
                          {translateWeather(index)}
                        </p>
                        {timeLineData.length > 0 && DayData(index)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
